import { createSystem, defineConfig, defaultConfig } from '@chakra-ui/react';

import { tableSlotRecipe } from './slotRecipes';
import { headingRecipe, linkRecipe } from './recipes';

export const theme = defineConfig({
  globalCss: {
    body: {
      bgColor: 'green.600',
    },
  },
  conditions: {
    statusActive: '&:is([data-status=active])',
  },
  theme: {
    tokens: {
      fonts: {
        body: { value: 'monoId' },
        heading: { value: 'monoId' },
      },
    },
    recipes: {
      heading: headingRecipe,
      link: linkRecipe,
    },
    slotRecipes: {
      table: tableSlotRecipe,
    },
  },
});

export default createSystem(defaultConfig, theme); // for CLI
